import React from 'react'
import { Link } from 'react-router'
import { GrayBadge, LightBlueBadge, DarkBlueBadge, RedBadge } from '../data-card/data-card-parts'

import QAServicingOptionsContainer from '../../containers/qa-servicings/qa-servicing-options-container'
import { DataCard, Details, Title } from '../data-card/data-card-parts'

export default ({
  qaServicing,
  area,
  qaWorkOrderId
}) => (
  <DataCard>
    <QAServicingOptionsContainer qaServicingId={qaServicing.id} />
    <Link to={`/quality-assurance/${qaWorkOrderId}/areas/${qaServicing.id}`}>
      <Details>
        <Title text={area.name || ''} />

        {statusBadge(qaServicing.status)}
      </Details>
    </Link>
  </DataCard>
)

function statusBadge (status) {
  const cases = {
    completed: <DarkBlueBadge text={status} />,
    approved: <LightBlueBadge text={status} />,
    denied: <RedBadge text={status} />,
    default: <GrayBadge text={status} />
  }

  return cases[status] || cases.default
}



// WEBPACK FOOTER //
// ./src/components/qa-servicings/qa-servicing-card.js